<div class="card" [ngClass]="{'card-expand':fullScreen, 'bg-emphasis':!fullScreen}">
  <div class="card-body p-2 m-3px" >

    <div class="d-flex fw-bold small mb-2 text-truncate text-uppercase" *ngIf="widget.showTitle">
      <span class="flex-grow-1">{{widget.name}}</span>
      <a class="text-default text-opacity-75 text-decoration-none" (click)="refresh()" data-bs-original-title="" title=""><i class="bi bi-arrow-repeat"></i></a>
      <a class="text-default text-opacity-75 text-decoration-none" (click)="toggleFullscreen()" data-bs-original-title="" title=""><i class="bi bi-fullscreen"></i></a>
    </div>
    <div class="card-body p-2 m-3px" *ngIf="widget.hidden">
      <div class="no-data-container" [style]="{height:chartOptions.chart.height + 'px'}">
        <div class="no-data-message">{{widget.noDataMessage}}</div>
      </div>      
    </div>
    <div class="card-body p-2 m-3px" *ngIf="!widget.hidden">
      <highcharts-chart *ngIf="timeSelect"
        [Highcharts]="Highcharts"
        [constructorType]="stockConstructor"
        [options]="chartOptions"
        [callbackFunction]="chartCallback"
        style="width: 100%; display: block">
      </highcharts-chart>
      <highcharts-chart *ngIf="!timeSelect"
        [Highcharts]="Highcharts"
        [constructorType]="chartConstructor"
        [options]="chartOptions"
        [callbackFunction]="chartCallback"
        style="width: 100%; display: block">
      </highcharts-chart>
    </div>
  </div>
</div>
